import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { canonicalPath } from '../../utils/canonicalUrl';

const SKIP_PREFIXES = ['/api', '/assets', '/static', '/app', '/admin', '/merchant', '/actuator'];
const HAS_FILE_EXT = /\.[a-z0-9]{2,8}$/i;

/**
 * Allinea l'URL del browser al path canonico con slash finale (coerente con nginx e canonical).
 */
const TrailingSlashRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === '/' || pathname.endsWith('/')) return;
    if (SKIP_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return;
    const last = pathname.split('/').pop();
    if (last && HAS_FILE_EXT.test(last)) return;

    const target = canonicalPath(pathname);
    if (target !== pathname) {
      navigate(`${target}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
};

export default TrailingSlashRedirect;
